<form [formGroup]="form">
  <bolt-tabset class="members">
    @for (member of members; track trackMembers(i, member); let i = $index) {
      <bolt-tablabel
        >{{ member.person?.firstName }}
        {{ member.person?.lastName }}
        @if (isMemberPni(member)) {
          (PNI)
        }
        @if (isMemberFormInvalid(i)) {
          <bolt-icon
            name="exclamation-circle-filled"
            size="sm"
            color="theme-error"
          ></bolt-icon>
        }</bolt-tablabel>
        <bolt-tabpanel>
          <nwx-tasks-members-form
            [index]="i"
            [member]="member"
            [policyholder]="policyholder"
            [memberTasks]="getMemberSpecificTasks(member)"
            [pniTasks]="pniTasks"
            [products]="products"
            (valueChange)="onValueChange($event)"
            (formReady)="addChildForm($event, i, 'member')"
            [submitted]="submitted"
            ></nwx-tasks-members-form
          ></bolt-tabpanel>
        }
      </bolt-tabset>
    </form>
